import { CONSTANT } from './constants';
import axios from 'axios';

let module = '';
let components = '';
let moduleSet = 'false';
let viewerI = 0 ;
let commonObject = {};
let ipAddress = '';

// Exposes the currently-loaded .glb's stone object names (matName#objName pairs)
// so components outside this module can resolve real node names instead of
// hardcoding them, since those names come from the .glb and can change on re-export.
export const getStoneOptions = () => commonObject?.stoneOptions || [];

export const isLayerFilterValid = (Layer,LayerDetails,filterCheck) => {
    for(var i=0 ;i<LayerDetails.length;i++){
        if(LayerDetails[i]['layer'].replace(/\s/g, "") === Layer.replace(/\s/g, "") && LayerDetails[i]['default_filter'] != null){
            let filter_check = LayerDetails[i]['default_filter'].split(",");
            for(var j=0;j<filter_check.length;j++){
                if(filter_check[j] === filterCheck){
                    return true;
                }
            }
        }
    }
    return false;
};
/*Use for the Family Builder*/
export const handleStoneCount = (layerparam) =>{
    let stone_count = layerparam['Layer 1']?.ShahItemDetails?.shah_api_product?.[0];
    if(stone_count){
        return stone_count.number_of_side_stone;
    }else{
        return [];
    }
}
/*Use for the Family Builder*/

/*Upddated the Stone color*/
export const handleStoneColorHologram = async (product_code,fileObject=null) => {
    let DiamondObject = '';
    let diamondColorCode = '';
    if(fileObject != null){
        DiamondObject = fileObject;
        diamondColorCode = product_code;
    }else{
        diamondColorCode = CONSTANT.Diamond_color[product_code];
        DiamondObject = findObject(commonObject,diamondColorCode,'diamond');
    }
    const canvasExists = document.querySelector('canvas');
    if (!canvasExists) {
        console.warn("Canvas tag not found in the DOM.");
        return {};
    }
    const objectList = typeof DiamondObject === 'string'
        ? DiamondObject.split(',').map(obj => obj.trim()).filter(Boolean)
        : Array.isArray(DiamondObject) ? DiamondObject : [DiamondObject];
    try{
        if(moduleSet == 'true'){
            if (module?.getOrCreateMaterial) {
                for (const objectName of objectList) {
                    await module.getOrCreateMaterial(objectName, diamondColorCode).then((material) => {
                        module.applyMaterialToObject(objectName, material) // Apply material directly to the object
                    })
                }
            }
        }
    }catch(error){
        console.warn(error);
    }
}
/*Upddated the Stone color*/

const findObject = (objectData, material, type) => {
    if (type === 'metal') {
        const shankOptions = objectData.metalOptions;
        if (shankOptions && shankOptions.length > 0) {
            for (let item of shankOptions) {
                const [matName, objName] = item.split("#");
                if (matName === material) {
                    return objName;
                }
            }
        }
    } else {
        const stoneOptions = objectData.stoneOptions;
        if (stoneOptions && stoneOptions.length > 0) {
            for (let item of stoneOptions) {
                const [matName, objName] = item.split("#");
                if (matName === material) {
                    return objName;
                }
            }
        }
    }
    return null;
};

/*Upddated the Metal color*/
export const handleMetalColorHologram = async (metalColor,fileObject,direactCall = null) => {
    // Direct DOM manipulation can be avoided in most cases
    let ShankObject = '';
    if(direactCall != null){
        ShankObject = fileObject; 
    }else{
        metalColor = CONSTANT.MetalColorShank[metalColor];
        ShankObject = '';
        ShankObject = findObject(commonObject,metalColor,'metal');
        if(fileObject == 'base' || fileObject == 'Object'){
            ShankObject = 'ShankMetalColour';
        }
        if(fileObject == 'element'  || fileObject == 'Prong'){
            ShankObject = 'HeadMetalColour';
        }
    }
    const canvasExists = document.querySelector('canvas');
    if (!canvasExists) {
        console.warn("Canvas tag not found in the DOM.");
        return {};
    }
    const objectList = typeof ShankObject === 'string'
        ? ShankObject.split(',').map(obj => obj.trim()).filter(Boolean)
        : Array.isArray(ShankObject) ? ShankObject : [ShankObject];

    if(moduleSet == 'true'){
        if (module?.getOrCreateMaterial) {
            for (const objectName of objectList) {
                try {
                    await module.getOrCreateMaterial(objectName, metalColor).then((material) => {
                        module.applyMaterialToObject(objectName, material) // Apply material directly to the object
                    })
                } catch (error) {
                    console.error(`Failed to apply material to ${objectName}:`, error);
                }
            }
        }
    }

} 
/*Upddated the Metal color*/

/*Hologram Viewer Context 3D-Viewer*/
export const initializeViewerNew = async(gbl, shouldDisposePrevious = false)=> {
    try{
        // Check if a canvas element exists
        const canvasExists = document.querySelector('canvas');
        if (!canvasExists) {
            console.warn("Canvas tag not found in the DOM.");
            return { module: null, components: null, moduleSet: false, error: "Canvas not found" };
        }
        // Hold a reference to the currently active module (if any) before it gets overwritten below,
        // so its ViewerApp instance can be disposed instead of leaking a running render loop.
        const previousModule = module;
        // Import the viewer script dynamically (remove import.meta dependency)
        const scriptURL = document.currentScript ? document.currentScript.src : ''; // Fallback if currentScript is undefined
        const baseScriptURL = scriptURL ? scriptURL : `${CONSTANT.BASE_URL}/assets/js/viewer/ijewels/genric_builder_ijewels-script-new.js`;

        // 3. Remove existing <script> tag if present
        const existingScript = document.querySelector(`script[src^="${baseScriptURL}"]`);
        if (existingScript) {
            existingScript.remove();
            console.log("Previous viewer script removed.");
        }

        // Add cache-busting parameter to force re-import
        const moduleUrl = `${baseScriptURL}?v=${Date.now()}`;

        if(shouldDisposePrevious && previousModule?.disposeViewer){
            try{
                await previousModule.disposeViewer();
            }catch(disposeError){
                console.warn('Failed to dispose previous viewer instance:', disposeError);
            }
        }

        module = await import(moduleUrl);
        if (module?.setupViewer) {
            const modelURL = gbl;
            await module.setupViewer(modelURL);
            components = await module.getComponentKeys();
            commonObject = components;
            moduleSet = 'true';
            // Optionally return the module, components, and status
            return { module, components, moduleSet: true };
        }else {
            // console.error("setupViewer function not found in the module.");
            return { module: null, components: null, moduleSet: false, error: "setupViewer function not found" };
        }
    }catch(error){
        return { module: null, components: null, moduleSet: false, error: error.message }; // Return consistent structure on error
    }
    
}

export const removeInstalizeViewwer = async() => {
    module = null;
    components = null;
    moduleSet = 'false';
    viewerI++;
    let existingScript = document.querySelector('script[src*="genric_builder_ijewels-script.js"]');
    if (existingScript) {
        existingScript.remove();
    }
    existingScript = document.querySelector('script[src*="bundle-0.9.20-logo-removed.js"]');
    if (existingScript) {
        existingScript.remove();
    }
}
/*Hologram Viewer Context 3D-Viewer*/

export const formatNumber = (num) => {
  return new Intl.NumberFormat('en-US').format(num);
};

// HIDE_DIAMOND_PRICE flag: any value other than 'No' hides the diamond price from the shopper
export const isDiamondPriceHidden = (flags) => !!flags?.['HIDE_DIAMOND_PRICE'] && flags?.['HIDE_DIAMOND_PRICE'] != 'No';


const nameMapping = {
  'amethist-diamond.dmat': 'Amethist',
  'aquamarine.dmat': 'Aquamarine',
  'black-diamond.dmat': 'Black Diamond',
  'blue-diamond.dmat': 'Blue Diamond',
  'brown-diamond.dmat': 'Brown Diamond',
  'citrine.dmat': 'Citrine',
  'diamond.dmat': 'Diamond',
  'emerald.dmat': 'Emerald',
  'morganit.dmat': 'Morganite',
  'peridot.dmat': 'Peridot',
  'pink-diamond.dmat': 'Pink Diamond',
  'rhodolite-garnet.dmat': 'Rhodolite Garnet',
  'ruby.dmat': 'Ruby',
  'sapphire.dmat': 'Sapphire',
  'tansanit.dmat': 'Tanzanite',
  'topas.dmat': 'Topas',
  'yellow-diamond.dmat': 'Yellow Diamond',
  'zircon-blue.dmat': 'Zircon Blue',
  'zircon-red.dmat': 'Zircon Red',
  'gold-white.pmat': 'White Gold',
  'gold-rose.pmat': 'Rose Gold',
  'gold-yellow.pmat': 'Yellow Gold',
};

const prettifyFilename = (filename) =>
  filename
    .replace(/\.[a-z]+$/, '')
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());

export const groupOptions = (entries) => {
  const fileToParts = {};

  // Step 1: Group all parts by file
  entries.forEach((entry) => {
    const [file, partsStr] = entry.split('#');
    if (!file || !partsStr) return;

    const parts = partsStr.split(',');
    if (!fileToParts[file]) fileToParts[file] = new Set();

    parts.forEach((part) => fileToParts[file].add(part));
  });

  const baseGroupMap = {};

  // Step 2: Group all parts by their base (e.g., AccentStones1 from AccentStones1_2)
  Object.entries(fileToParts).forEach(([file, partSet]) => {
    const name = nameMapping[file] || prettifyFilename(file);
    const parts = Array.from(partSet);

    const baseMap = {};

    // Find base groups: CenterStone, AccentStones1, etc.
    parts.forEach((part) => {
      const base = part.split('_')[0]; // e.g. AccentStones1 from AccentStones1_3
      if (!baseMap[base]) baseMap[base] = [];
      baseMap[base].push(part);
    });

    // For each base, assign the option to the correct dropdown
    Object.entries(baseMap).forEach(([base, fullParts]) => {
      if (!baseGroupMap[base]) baseGroupMap[base] = [];

      const value = `${file}#${fullParts.join(',')}`;
      baseGroupMap[base].push({ name, value });
    });
  });

  // Step 3: Format the output
  return Object.entries(baseGroupMap).map(([base, options]) => ({
    part: base,
    base,
    options,
  }));
};

export const pushDataLayerEvent = (eventName, payload = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...payload });
};

export const updateLogs = (project_name, message, account_no, holo_item, holo_cat, parameter) => {
    axios.post(`${CONSTANT.BASE_URL}api/Builder/update-tracking-log`, {
        apiParams: {
            ipAddress: ipAddress,
            project_name: project_name,
            message: message,
            account_no: account_no,
            holo_item: holo_item,
            holo_cat: holo_cat,
            parameter: parameter
        }
    });
}

export const fetchIPAddress = async () => {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    ipAddress = data.ip;
}